import Contact from "./Contact";

const Home = () => {
    return(
        <div className="footer">
            <Contact/>
            <p>animation made with <a href="https://p5js.org">p5.js</a></p>
        </div>
    )
}

export default Home;